import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Router } from '@angular/router';

import { AuthService } from './auth.service';

@Component({
  selector: 'login-form',
  template: require('./login-form.component.html')
})

export class LoginFormComponent {
  constructor(private userService: AuthService, private router: Router) { }
  username: string;
  password: string;
  loginSuccess = true;

  onSubmit() {
    this.userService.login(this.username, this.password, (err)=> {
      this.loginSuccess = false;
    });
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/auth/login-form.component.ts
 **/